import { apiService } from "../../services/apiService";
import { apiServiceConstants } from "../../constants";
import { utilService } from "../../services/utilService";
import { doctorsListService } from "../../components/Shared/DoctorList/doctor-list-service";
import {
  FileShareFullListInterface,
  FileShareFullListModel,
  FileShareFullListResult,
} from "../FileShare/components/SelectUserComponent/SelectUserComponent.model";

const getSearchResultData = async (params: any) => {
  const respApiResult = await apiService
    .apiCall(
      `user/global-user-search-list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {      
      const usersListResp = res as FileShareFullListModel;
      var resultData: any;
      if (usersListResp.result) {
        resultData = mapFileShareFullListResult(usersListResp.result);
      }
      const result: FileShareFullListInterface = {
        isSuccess: true,
        status: usersListResp.status,
        message: usersListResp.message,
        result: resultData,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const mapFileShareFullListResult = (
  payload: Array<FileShareFullListResult>
) => {
  let resultListArray = payload.map((object: FileShareFullListResult) => {
    return {
      count: object.count,
      next: object.next,
      previous: object.previous,
      data: doctorsListService.setDoctorListModel(object.data),
    };
  });
  return resultListArray;
};

const addFavoriteUsers = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/add-user-to-favorite/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: userListResp.isSuccess,
        result: userListResp.result,
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const handleErrorResponse = () => {};

const fetchSitesList = async (params: any) => {
  const respApiResult = await apiService
    .apiCall(
      `n2n-communication/n2n-sites/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {      
      const usersListResp = res as FileShareFullListModel;
      return usersListResp;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const fetchUsers = async (params: any) => {
  const respApiResult = await apiService
    .apiCall(
      `n2n-communication/n2n-search?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {      
      const usersListResp = res as FileShareFullListModel;
      return usersListResp;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

export const globalSearchService = {
  handleErrorResponse,
  getSearchResultData,
  addFavoriteUsers,
  fetchUsers,
  fetchSitesList
};
